import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
     name: 'segmentPipe'
})
export class SegmentPipe implements PipeTransform {
    transform(id: number, list: any[]): string {
        let category = list.filter(x => x.adminStrId == id)[0];

        return category?.name;

    }
}
